
export const MAX_ALLOWED_DISTANCE = "max-allowed-distance";

const apiCodes = {
    MAX_ALLOWED_DISTANCE,
}

export default apiCodes;